import React, { Component } from 'react';
import { VariableInput } from '.';
import { HelpImageContainer, HelpImageViewer, HtmlComponent, SvgImage } from '../../../../components';
import { getValues, getUnit } from '../../../../util';
import classNames from 'classnames';
import { PropTypes } from 'prop-types';
import { CloseLightIconNew, addonsInfoIcon, closeIcon, closePopup } from '../../../../../style/images';
import { VariableType } from '../../../../model';
import { translate } from '../../../../services';
import { combineStates, screenSizeState } from '../../../../store';
import { connect } from 'react-redux';
import { Box, Dialog, IconButton as MuiIconButton } from '@mui/material';

export class VariableComponents extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      showImage: false,
      image: null,
    };
  }

  getText = item => {
    if ( Array.isArray( item ) ) {
      const assignedValue = this.props.variable.assignedValue;
      const language = this.props.language;
      //dev-2510: display translated assigned value on UI  
      return assignedValue && assignedValue.properties[language]?assignedValue.properties[language]:assignedValue && assignedValue.title;
    }

    return item && item.title;
  }

  getValue = item => {
    return item && item.name;
  }
  
  changeValue = newValue => {
    const { variable, selectedValue, assignValue, removeValue, fromFeasibility } = this.props;   

    if(fromFeasibility){
      newValue = {...newValue, userAssigned: true};
    }
    
    if( selectedValue === newValue.name && !fromFeasibility) {
      removeValue( variable.fullyQualifiedName, newValue.name );
      variable.assignedValue = null;
    } else {
      assignValue( variable.fullyQualifiedName, newValue.name );
      variable.assignedValue = newValue;
    }
  }

  onRemove = () => {
    const { removeValue, selectedValue, variable } = this.props; 
    removeValue( variable.fullyQualifiedName, selectedValue );
  }

  setImage = (image)=>{
    this.setState({showImage:true, image:image})
  }
  closeImage = ()=>{
    this.setState({showImage:false})
  }
  render() {
    const { configuration, language, selectedValue, variable, variables,placeholder_value } = this.props; 
    const data = getValues( variable, variable.values, language, configuration.materialKey );
    const label = variable.title + getUnit( variable, variables, configuration.materialKey );
    const isUserAssigned = variable.assignedValue && variable.assignedValue.state === 1;
    const variableType = variable.properties.CustomType ? variable.properties.CustomType : (VariableType.isNumber( variable.type ) ? variable.type : 'text');
    const filter = variable.fullyQualifiedName == "Selector.varCompleteratioA" ? "startsWith": "contains";
    
    return variable.show &&  data.length>0 && <div className={ classNames( 'row', 'field', { 'required': variable.properties.Required && !selectedValue } ) }>
      <div className={ classNames( 'col-5 label', { 'extra-info': variable.properties.Info } ) }>
        <HtmlComponent tooltip={ label } item={ label }/>
        <HelpImageViewer selectorName={ configuration.materialKey } filterName= { variable.name } displayName={ label } defaultFilter={variable.properties?.EN} image={this.state.image} setImage={this.setImage}/>
      </div>
      <div className='dropdow-container'>
        <div 
          className="col-7 value"
          title={ variable.properties.valid ? undefined : variable.properties.validMessage }
        >
          { variable.properties.Info && <span>{ variable.properties.Info }</span> }
          <VariableInput
            assignedValue={variable.assignedValue}
            disabled={ variable.properties.ReadOnly || variable.notEnabled }
            model={ configuration.materialKey }
            fqn={ variable.fullyQualifiedName }
            showAs={ variable.showAs.toLowerCase() }
            calculatedValue={ variable.properties.CalculatedValue }
            data={ data } 
            custom={variable.custom}
            textField={ this.getText }
            valueField={this.props.fromUiGroup?null: this.getValue }
            onChange={ this.changeValue }
            value={ selectedValue }
            selectedValue = {selectedValue}
            type={ variableType }
            max={ variable.properties.Max || variable.properties.MaxValue }
            min={ variable.properties.Min || variable.properties.MinValue }
            filter = {filter}
            placeholder_value={placeholder_value}
          />
        </div>
        
        {/* <div className="remove-icon"> */}
        {
          console.log('this.props.screenSize.width - ', this.props.screenSize.width)
        }
        <div className="delete-icon" style={(!['text', 'float'].includes(variableType) && this.props.screenSize.width <= 900) ? {right: 40} : {}}>
          {
            isUserAssigned && 
              <SvgImage 
                source={ CloseLightIconNew }  
                toolTip={ translate( 'Remove assignment' ) }
                onClick={ this.onRemove }
              />
          }
          </div>
        {/* </div> */}
      </div>
          
      {/* to show help image for model configurators */}
      <Dialog open={this.state.showImage} sx={{width:"100%", height:"100%", padding:'32px'}} onClose={this.closeImage} PaperProps={{sx:{
      display: 'inline-flex',
      // padding: "32px 24px",
      justifyContent: "center",
      alignItems: "center",
      gap: "24px",
      borderRadius: "4px",
      background: "#FFF",
      overflow:"hidden",
      margin:"0px",
      height:"max-content",
      width:"max-content",
      maxWidth:"100%",
      maxHeight: "100%"
    }}}>
      <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.closeImage} style={{width:"24px", height:"24px"}} sx={{display:"flex",position:"absolute", top:"12px", right:"12px", background:"#F5F5F5", height:"20px", width:"20px", borderRadius:"56px" , backgroundColor: 'white'}}>
              <Box component="img" src={closePopup} style={{width: '24px', height: '24px'}} sx={{height:"16px", width:"24px"}}></Box>
            </MuiIconButton>
        {/* <Box component="img" src={closePopup} onClick={this.closeImage} sx={{fill:"#868686", width:"24px", height:"24px", position: "absolute",
          right: "12px",
          top: "12px"}}></Box> */}
                  <HelpImageContainer filterName= { variable.title } image={ this.state.image } onClose={this.closeImage}/>  
    </Dialog>
    </div>;
  }
}

VariableComponents.propTypes = {
  assignValue: PropTypes.func.isRequired,
  language: PropTypes.string, 
  removeValue: PropTypes.func.isRequired,
  selectedValue: PropTypes.string, 
  variable: PropTypes.shape( {
    assignedValue: PropTypes.object,
    name: PropTypes.string.isRequired,
    properties: PropTypes.object,
    show: PropTypes.bool.isRequired,
    showAs: PropTypes.string.isRequired,
  } ), 
  variables: PropTypes.arrayOf( PropTypes.object )
};


export const Variable = connect(combineStates(screenSizeState))(VariableComponents);